export default [
    {
        path: '/presentation/day/prefill',
        props: true,
        component: () => import('@/views/Proposal/Presentation/Day/Prefill/index'),
    },
];
